import React, { useEffect, useState } from "react";
import { useParams} from "react-router-dom";
import sanityClient from "../client";
// import { FaArrowLeft, FaMapMarker } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import Container from "./atoms/Container";
import styled from "styled-components";
import TournamentItem from "./TournamentItem";
import {CSVLink} from 'react-csv'
import axios from 'axios'


const Title = styled.h3`
  color: rgba(31, 41, 55, 1);
 
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 2rem;
  margin-bottom: 0.25rem;
  text-align: center;
`;

const StyleList = styled.div`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  padding: 24px;
  background-color: white;
  position: relative;

  box-shadow:
    0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);

  @media only screen and (max-width: 40em) {
    padding: 12px 8px;
  }
`;
const TableWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const TourContainer = styled(Container)`
  width: calc(100% - 24px);
  max-width: 900px;
  margin: 0 auto;
  box-sizing: border-box;

  @media only screen and (max-width: 40em) {
    width: calc(100% - 20px);
    margin: 0 auto;
    padding: 0;
  }
`;

const StyleTable = styled.table`
  width: 100%;
  max-width: 100%;

  margin: 40px auto 0;

  border: 1px solid;
  border-collapse: collapse;

  text-align: center;

  th,
  td {
    padding: 8px 10px;
  }

  @media only screen and (max-width: 40em) {
    margin-top: 24px;
    font-size: 14px;

    th,
    td {
      padding: 7px 6px;
    }
  }
`;


const StyleRowFirst = styled.tr`
  border: 2px solid;
  border-color: black black grey black;

  white-space: normal;
`;

const StyleRowSecond = styled.tr`
  border: 2px solid;
  background-color: lightblue;
`;

const renderHeader = () => {
    return (
    <thead>
    <StyleRowSecond key='header'>
      <th>L.p</th><th>Imię i Nazwisko</th><th>WK</th><th>PID</th>
    </StyleRowSecond>
    </thead>)
  }

const renderTeamHeader = () => {
return (<thead>
      <StyleRowSecond key='header'>
          <th>L.p</th><th>Nazwa teamu</th><th>Imię i Nazwisko</th><th>WK</th><th>PID</th>
      </StyleRowSecond>
      </thead>)
}

const span = 2


const  RegistrationPage = () => {
    const [registrationPage, setRegistrationPage] = useState(null);
    const { slug } = useParams();
    const [players, setPlayers] = useState([]);
    const [playersCount, setPlayersCount] = useState(0);

    useEffect(() => {
        sanityClient
          .fetch(
            `*[slug.current == "${slug}"]{
                title, 
                date,
                date_registration,
                slug,
                typeName,
                description,
                regFee,
                Fee,
                redFee,
                limit,
            }`
          )
          .then((data) => setRegistrationPage(data[0]))
          .catch(console.error);
        
        
        

      },[slug]);
      
      useEffect(() => {
        if (registrationPage) {
          if (registrationPage.typeName === 'couples') {
    
            const fetchPairs = async () => {
              const apiUrl =  `https://brydzwroclaw.com/v1/pairs/${slug}`   
              try {
                const res = await axios.get(apiUrl, slug)
                console.log(res.data)
                setPlayers(res.data)
                setPlayersCount((res.data.length)/2)
                
              } catch(error){
                console.log('Error fetching data', error)
              }
            }
            
            fetchPairs()
          };

          if (registrationPage.typeName === 'teams') {
              const fetchTeams = async () => {
                // const apiUrl = `http://localhost:8080/teams?tournament=${slug}`
                const apiUrl = `https://brydzwroclaw.com/v1/teams/${slug}`
                console.log(apiUrl)
                try {
                  const res = await axios.get(apiUrl)
                  
                  setPlayers(res.data)
                
                } catch(error){
                  console.log('Error fetching data', error)
                }
              }
              
              fetchTeams()
          }
        };
        },[registrationPage]);

      if (!registrationPage) return <div>Ładowanie...</div>;
      
      const csvData = () => { 
          if (registrationPage.typeName === 'teams') {
            return players.map(item=>(
              {
                team: item.team,
                tournament: item.tournament,
                name: item.player_name,
                WK: parseFloat(item.WK),
                PID: item.PID
              })
            )
            }
            else {
              return players.map((item, index)=>({
                  tournament: item.tournament,
                  index: Math.ceil((index+1)/2),
                  name: item.player,
                  WK: item.WK,
                  PID: item.PID
              }
              ))
              }
        }

      // const csvData = () => { 
      //     if (registrationPage.typeName === 'teams') {
      //       console.log(players)
      //       return players.map(item=>(
      //         console.log(item)
      //       ))
      //     }
      //   };
  
        const flat =() => {
            const flaten = {}
            csvData.map((item, index) => {
                let size = item.length
                item.map((inneritem, innerindex) =>{
                    flaten[size*index+innerindex] = inneritem 
                } ) 
            })
            return Object.values(flaten) 
        };
      
        const finalData = () => {  
          if(registrationPage.type === 'teams'){
            return flat() }
          else{
            return csvData()}
        }
      
    const csvDataOst = finalData()

    const fileHeaders = (type) => {
      if (type === 'teams')
        return [
        {label: "Team", key: "team"},
        {label: "Turniej", key: "tournament"},
        {label: "Gracz", key: "name"},
        {label: "WK", key: "WK"},
        {label: "PID", key: "PID"},
        ]
      else
        return [
          {label: "Turniej", key: "tournament"},
          {label: "Numer pary", key: "index"},
          {label: "Gracz", key: "name"},
          {label: "WK", key: "WK"},
          {label: "PID", key: "PID"},]
      }

    const CreateCSV = () =>{
        console.log(<CSVLink
          className="bg-indigo-500 hover:bg-indigo-600 text-white text-center font-bold py-2 px-4 rounded-full w-full focus:outline-none focus:shadow-outline mt-4 block"
          headers={fileHeaders(registrationPage.typeName)}
          data={csvDataOst}
          filename={`registered_${slug}.csv`}
          target="_blank"
        >
          Exportuj do CSV
        </CSVLink>)
        return (
            <div>
              {csvDataOst?.length &&
                <CSVLink
                  className="bg-indigo-500 hover:bg-indigo-600 text-white text-center font-bold py-2 px-4 rounded-full w-full focus:outline-none focus:shadow-outline mt-4 block"
                  headers={fileHeaders(registrationPage.typeName)}
                  data={csvDataOst}
                  filename={`registered_${slug}.csv`}
                  target="_blank"
                >
                  Exportuj do CSV
                </CSVLink>
              }
            </div>
          );
    }

    const renderPlayers = () => {
        const id = (index) => (index+1)
        return (<tbody>
        {players.map((data, index) => { 
          return (
            <>
            {index%2 === 0 ?  <StyleRowFirst key = {index}> 
            <td rowSpan={span}>{id(index)/2+0.5}</td>
            <td>{data.player}</td>
            <td>{data.WK}</td>
            <td>
            <Link
            to= {`//msc.com.pl/cezar/?p=21&pid_search=${data.PID}`}>{data.PID}</Link></td>
            </StyleRowFirst> : 
            
            <StyleRowSecond key = {1000+index}>
            <td>{data.player}</td>
            <td>{data.WK}</td>
            <td><Link
            to= {`//msc.com.pl/cezar/?p=21&pid_search=${data.PID}`}>{data.PID}</Link></td>
            </StyleRowSecond>
            }
            </>
            )})
          } </tbody>)
        }
   
      const renderTeams = () => {
        const counter  = (index, count) => (index+count)
        const render_one_player = (team,inner_index, index, team_index) => {
          if (inner_index === 0){
            console.log(parseInt(team.player_count))
            return (
              <StyleRowFirst key={index}>
              <td rowSpan={parseInt(team.player_count)}>{team_index}</td>
              <td rowSpan={parseInt(team.player_count)}>{team.team}</td>
              <td>{team.player_name}</td>
              <td>{team.WK}</td>
              <td><Link
              to= {`//msc.com.pl/cezar/?p=21&pid_search=${team.PID}`}>{team.PID}</Link></td></StyleRowFirst>
              )
              }
          if (inner_index % 2 === 1) {
            return(
              <StyleRowSecond key ={index}>
              <td>{team.player_name}</td>
              <td>{team.WK}</td>
              <td><Link
              to= {`//msc.com.pl/cezar/?p=21&pid_search=${team.PID}`}>{team.PID}</Link></td></StyleRowSecond> 
            )
          }
          return (
          <StyleRowFirst key = {index}><td>{team.player_name}</td>
              <td>{team.WK}</td>
              <td><Link
              to= {`//msc.com.pl/cezar/?p=21&pid_search=${team.PID}`}>{team.PID}</Link></td></StyleRowFirst>
          )
        }
        
        let count = 0
        let index_count = 0

        return (
        <tbody>
        {players.map((team, index) => {
            console.log(team)
            if ( index - count === 0 ) {
              count = counter(index, team.player_count)
              index_count = index_count + 1
            }
            return(
              <>
              {render_one_player(team,index+team.player_count - count, index, index_count )}
              </>
            )
            })}
        </tbody>
        )
      }

    return (
        <>
        <section>
            <div className="container m-auto py-6 px-6">
                <Link
                to="/zapisy"
                className="text-indigo-500 hover:text-indigo-600 flex items-center"
                >
                <button className='mr-2'> Wroc do zapisów </button> 
                </Link>
            </div>
            </section>

            <TourContainer>
            <TournamentItem item = {registrationPage} slug = {slug} count = {playersCount} />



            <StyleList key = 'zapisani'>
                <Title>Obecnie zapisani</Title>
                <TableWrapper>
                <StyleTable>
                    {registrationPage.typeName === "couples" ? renderHeader() : renderTeamHeader() }
                    {registrationPage.typeName === "couples" ? renderPlayers() : renderTeams() }

                </StyleTable>
                </TableWrapper>
            </StyleList>

        {CreateCSV(slug)}       
        </TourContainer>
        
        </>
  )
}

// const playerLoader = async ({param}) => {
//     // const res = await fetch(`http://localhost:8000/tournaments/?_tournament=${param.tournament}`)
//     const res = await fetch(`http://localhost:8000/tournaments/${param.id}`)
//     const data = await res.json()
//     return data
// } 

export {RegistrationPage as default}